module.exports = __webpack_public_path__ + "static/media/icon-rank-mini-2.a3639b57.png";